var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFilterArrow = function SvgNoFilterArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59 7.778a.312.312 0 1 0 .625 0zM3.123.682a.31.31 0 0 0-.442 0L.693 2.672a.312.312 0 1 0 .442.441l1.767-1.768L4.67 3.113a.312.312 0 1 0 .442-.442zm.092 7.096V.903H2.59v6.875zM7.242 3.403a.312.312 0 1 1 .625 0zm.534 7.096a.313.313 0 0 1-.442 0L5.345 8.511a.312.312 0 1 1 .442-.442l1.768 1.767L9.322 8.07a.313.313 0 0 1 .442.442zm.091-7.096v6.875h-.625V3.403z"
  }))));
};
export default SvgNoFilterArrow;